import PhotoViewer from "photoviewer";

let zoomLevel = 0;
let pauseThrottle = false;

function throttle(callback) {
  if (pauseThrottle) return;

  pauseThrottle = true;
  setTimeout(() => {
    callback();
    pauseThrottle = false;
  }, 500);
}

function handlePhotoviewerKeypress(event, context) {
  if (event.key === "Escape") {
    context.close();
  }
}

function handlePhotoViewerClickEvent(event, context) {
  if (event.target.classList.contains("photoviewer-modal")) {
    context.close();
  }
}

function initFullScreenImage(img) {
  img.addEventListener("click", e => {
    e.preventDefault();

    const imageSrc = img.dataset.original || img.src;

    // eslint-disable-next-line no-undef,no-new
    new PhotoViewer([{ src: imageSrc }], {
      index: 0,
      // Can the whole modal be dragged
      draggable: false,
      // Can the whole modal be resized
      resizable: false,
      // Can the image be moved within the modal
      movable: true,
      keyboard: true,
      // Shows title in the header
      title: false,
      /**
       * This option will set photoviewer's size when it opened.
       * If false, the modal initialized size will fit to image size.
       * If true, the modal initialized size will be set with modalWidth and modalHeight.
       */
      fixedModalSize: false,
      /**
       * If false, the modal size will be set of image size or what you set with modalWidth and modalHeight.
       * If true, the modal size will be set maximized when initialized just like other lightbox.
       */
      initMaximized: true,
      initAnimation: true,
      animationDuration: 500,
      gapThreshold: 0,
      headerToolbar: ["close"],
      footerToolbar: ["zoomOut", "zoomIn"],
      icons: {
        zoomIn: "",
        zoomOut: ""
      },
      callbacks: {
        // When the modal is opened
        opened(context) {
          // Disable the zoom out button
          const zoomOutButton = document.querySelector(
            ".photoviewer-button-zoomOut"
          );

          zoomOutButton.classList.remove("photoviewer-button-zoomOut--enabled");

          const zoomInButton = document.querySelector(
            ".photoviewer-button-zoomIn"
          );
          zoomInButton.classList.add("photoviewer-button-zoomIn--enabled");

          // Reset zoom level counter
          zoomLevel = 0;

          document.addEventListener("keydown", event =>
            handlePhotoviewerKeypress(event, context)
          );

          document.addEventListener("click", event => {
            handlePhotoViewerClickEvent(event, context);
          });
        },
        beforeClose(context) {
          document.removeEventListener("keydown", event =>
            handlePhotoviewerKeypress(event, context)
          );

          document.removeEventListener("click", event =>
            handlePhotoViewerClickEvent(event, context)
          );
        }
      }
    });
  });
}

document.addEventListener("DOMContentLoaded", () => {
  const fullScreenImages = document.querySelectorAll("img.full-screen-image");

  fullScreenImages.forEach(img => {
    // Wrap image in full-screen-image-wrapper if not already wrapped (for content blocks)
    if (!img.parentElement.classList.contains("full-screen-image-wrapper")) {
      const wrapper = document.createElement("div");
      wrapper.classList.add("full-screen-image-wrapper");
      img.parentNode.insertBefore(wrapper, img);
      wrapper.appendChild(img);
    }

    initFullScreenImage(img);
  });

  // Reset buttons and zoom levels when window is resized
  window.addEventListener(
    "resize",
    throttle(() => {
      // Disable the zoom out button
      const zoomOutButton = document.querySelector(
        ".photoviewer-button-zoomOut"
      );

      if (zoomOutButton) {
        zoomOutButton.classList.remove("photoviewer-button-zoomOut--enabled");
      }

      // Enable the zoom in button
      const zoomInButton = document.querySelector(".photoviewer-button-zoomIn");

      if (zoomInButton) {
        zoomInButton.classList.add("photoviewer-button-zoomIn--enabled");
      }

      // Reset zoomOutClicks counter
      zoomLevel = 0;
    })
  );

  document.addEventListener("click", e => {
    const zoomInButton = document.querySelector(".photoviewer-button-zoomIn");
    const zoomOutButton = document.querySelector(".photoviewer-button-zoomOut");

    if (e.target.classList.contains("photoviewer-button-zoomIn")) {
      zoomLevel += 1;

      if (zoomLevel > 0) {
        // Enable the zoom out button
        zoomOutButton.classList.add("photoviewer-button-zoomOut--enabled");

        if (zoomLevel > 3) {
          // Disable the zoomInButton
          zoomInButton.classList.remove("photoviewer-button-zoomIn--enabled");
        }
      }
    } else if (e.target.classList.contains("photoviewer-button-zoomOut")) {
      zoomLevel -= 1;

      // Re-enable the zoomInButton
      zoomInButton.classList.add("photoviewer-button-zoomIn--enabled");

      if (zoomLevel <= 0) {
        // Disable the zoomOutButton
        zoomOutButton.classList.remove("photoviewer-button-zoomOut--enabled");
      }
    }
  });
});
